import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/arrow_left_black.svg'
import _imports_1 from '@/assets/images/arrow_left_forward.png'


const _hoisted_1 = { class: "v-card" }
const _hoisted_2 = { class: "v-card-header" }
const _hoisted_3 = { class: "d-flex align-items center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "svg align-text-bottom text-black me-1",
  height: "18",
  width: "18",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "flex-fill" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "svg align-text-bottom text-black me-1",
  height: "18",
  width: "18",
  src: _imports_1
}, null, -1)
const _hoisted_8 = { class: "v-card-body" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { for: "Code" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_13 = { for: "NameEn" }
const _hoisted_14 = ["placeholder", "disabled"]
const _hoisted_15 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_16 = { for: "NameFr" }
const _hoisted_17 = ["placeholder", "disabled"]
const _hoisted_18 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_19 = { for: "NameRw" }
const _hoisted_20 = ["placeholder", "disabled"]
const _hoisted_21 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_22 = { class: "col-md-12 form-group" }
const _hoisted_23 = { for: "Description" }
const _hoisted_24 = ["placeholder", "disabled"]
const _hoisted_25 = { class: "mx-3 my-4" }
const _hoisted_26 = { class: "mt-4" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_RouterLink, { to: "/app/products/categories/list" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.windowTitle) + " ", 1),
          (_ctx.nbrSubCategories>0)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_6, _toDisplayString('(' +  String(_ctx.nbrSubCategories) + ')'), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.categoryKey.length > 0)
          ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              to: _ctx.subCategoriesLink
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.language.sub_categories), 1),
                _createTextVNode("  "),
                _hoisted_7
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-6 form-group", { 'has-error': _ctx.v$.dataRecord.Code.$error }])
        }, [
          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.language.code), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "Code",
            class: "capletter form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataRecord.Code) = $event)),
            placeholder: '(' + _ctx.language.code.toLowerCase() + ')',
            maxlength: "10",
            autocomplete: "off",
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: true
          }, null, 40, _hoisted_11), [
            [_vModelText, _ctx.dataRecord.Code]
          ]),
          (_ctx.v$.dataRecord.Code.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.v$.dataRecord.Code.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-6 form-group", { 'has-error': _ctx.v$.dataRecord.NameEn.$error }])
        }, [
          _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.language.name + ' (en)'), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "NameEn",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataRecord.NameEn) = $event)),
            placeholder: '(' + _ctx.language.name.toLowerCase() + ' (en))',
            maxlength: "35",
            autocomplete: "off",
            onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord || _ctx.isLoading
          }, null, 40, _hoisted_14), [
            [_vModelText, _ctx.dataRecord.NameEn]
          ]),
          (_ctx.v$.dataRecord.NameEn.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.v$.dataRecord.NameEn.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-6 form-group", { 'has-error': _ctx.v$.dataRecord.NameFr.$error }])
        }, [
          _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.language.name + ' (fr)'), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "NameFr",
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataRecord.NameFr) = $event)),
            placeholder: '(' + _ctx.language.name.toLowerCase() + ' (fr))',
            maxlength: "35",
            autocomplete: "off",
            onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord || _ctx.isLoading
          }, null, 40, _hoisted_17), [
            [_vModelText, _ctx.dataRecord.NameFr]
          ]),
          (_ctx.v$.dataRecord.NameFr.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.v$.dataRecord.NameFr.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-6 form-group", { 'has-error': _ctx.v$.dataRecord.NameRw.$error }])
        }, [
          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.language.name + ' (rw)'), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "NameRw",
            class: "form-control",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dataRecord.NameRw) = $event)),
            placeholder: '(' + _ctx.language.name.toLowerCase() + ' (rw))',
            maxlength: "35",
            autocomplete: "off",
            onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord || _ctx.isLoading
          }, null, 40, _hoisted_20), [
            [_vModelText, _ctx.dataRecord.NameRw]
          ]),
          (_ctx.v$.dataRecord.NameRw.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.v$.dataRecord.NameRw.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.language.description), 1),
          _withDirectives(_createElementVNode("textarea", {
            id: "Description",
            class: "form-control",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dataRecord.Description) = $event)),
            placeholder: '(' + _ctx.language.description.toLowerCase() + ')',
            maxlength: "500",
            autocomplete: "off",
            onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord || _ctx.isLoading,
            rows: "4"
          }, null, 40, _hoisted_24), [
            [_vModelText, _ctx.dataRecord.Description]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block",
            disabled: _ctx.v$.$invalid || _ctx.isSavingRecord || _ctx.isLoading,
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.saveNewCateg && _ctx.saveNewCateg(...args)))
          }, [
            (_ctx.isSavingRecord)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-spinner'] }),
                  _createTextVNode("  ")
                ]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
          ], 8, _hoisted_27)
        ])
      ])
    ])
  ]))
}